<template>
  <div>
    <div class="navWarp">
      <div class="inner">
        <img src="../../assets/images/logoNew.png" @click="goSomePage({link:'/'})" style="cursor: pointer">
        <ul class="navList">
          <li class="navItem" v-for="(item,index) in navList" :class="{'active':(item.link.indexOf(path)>=0?true:false)}" v-show="item.isLoginShow || item.isOutIndex" @click="goSomePage(item)">{{item.name}}</li>
        </ul>
        <div class="btns" v-show="!isLogin">
          <div class="login btn" @click="goSomePage({link:'/login'})">登录</div>
          <div class="re btn"@click="goSomePage({link:'/register'})">注册</div>
        </div>
        <div class="userWarp" @click="showOut" v-if="isLogin">
          <img :src="'http://absign.oss-cn-beijing.aliyuncs.com/'+gUserInfo.userDetailResult.user_photo" class="userImg" alt="">
          <span class="userName">{{gUserInfo.userDetailResult.username}}</span>
          <span class="userSj"></span>
          <div class="outWarp" v-show="showOutBloor">
            <div class="item"  @click="goSomePage({link:'/msg'});indexData.messageCount =0;">消息提醒<span v-show="indexData.messageCount>0">{{indexData.messageCount}}</span></div>
            <div class="item" @click="goSomePage({link:'/personal'})">用户信息</div>
            <div class="item" @click="goout">退出登录</div>
            <div class="triangle_border_up">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapActions, mapGetters} from 'vuex'
  export default {
    data() {
      return {
        showOutBloor:false,
        isLogin: false,
        navList: [],
        indexData:{},
        isOutIndex:false,
        path:this.$route.path.split('/')[1]
      }
    },
    computed:{
      ...mapGetters([
        "gUserInfo"
      ])
    },
    created() {
      let _this = this;
      if(this.gUserInfo.token && this.gUserInfo.userDetailResult){
        this.isLogin = true;
        _this.ajpost('/api/account/index',{},function (data) {
          _this.indexData = data.data;
        })
      }
      this.isOutIndex = true
      _this.navRolad()
    },
    methods: {
      ...mapActions([
        "aUserInfo"
      ]),
      goSomePage(item) {
          if (!this.gUserInfo.token && item.link =='/personal') {
            this.$router.push('/login')
          }else if (!this.gUserInfo.token && item.link =='/lindex') {
            this.$router.push('/')
          }else {
            this.$router.push(item.link)
          }
      },
      goout(){
        this.clearAllCookie();
        this.aUserInfo({});
        this.$router.push('/');
        location.reload();
      },
      clearAllCookie() {
        let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if(keys) {
          for(let i = keys.length; i--;)
            document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
        }
      },
      showOut(){
        this.showOutBloor = !this.showOutBloor;
      },
      navRolad(){
        let _this = this;
        this.navList = [
          {name: '首页', link: '/lindex', isLoginShow: _this.isLogin,isOutIndex:_this.isOutIndex},
          {name: '用户中心', link: '/personal', isLoginShow: _this.isLogin,isOutIndex:_this.isOutIndex},
          {name: '文档管理', link: '/documentList/5', isLoginShow: _this.isLogin,isOutIndex:!_this.isOutIndex},
          {name: '在线验签', link: '/online', isLoginShow: !_this.isLogin,isOutIndex:_this.isOutIndex},
          {name: '关于ABSign', link: '/about', isLoginShow: !_this.isLogin,isOutIndex:_this.isOutIndex},
          {name: '帮助中心', link: '/help', isLoginShow: !_this.isLogin,isOutIndex:_this.isOutIndex},
        ]
      }
    },
    watch:{
      $route(to,from){
        if(to.path =='/'){
          this.isOutIndex = true;
          this.navRolad();
        }
        if(to.matched[1].path.indexOf('userCenter')>=0){
          this.path = 'personal'
        }else {
          this.path = to.path.split('/')[1]
        }
      }
    }
  }
</script>
<style>
  @import "../../assets/less/nav.css";
  .userSj{
    width: 20px;
    height: 20px;
    display: inline-block;
    background: red;
    background: url("../../assets/images/sj.png");
    background-size: 100% 100%;
    vertical-align: -5px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/nav.vue